import { localizedNumber } from "../../../../utils/help/localization/localization";
import { LoyaltyTierBadge } from "../Badge/LoyaltyTierBadge";
import styles from "./LoyaltyTierRing.module.scss";

/** Figma ring: 79.44px outer diameter, 2px progress stroke, 5.5px tier band. */
const CENTER = 39.72;
const PROGRESS_RADIUS = 38.72;
const BAND_OUTER_RADIUS = 34.55;
const BAND_INNER_RADIUS = 29.05;
const PROGRESS_CIRCUMFERENCE = 2 * Math.PI * PROGRESS_RADIUS;

interface LoyaltyTierRingProps {
  rank: number;
  color: string;
  /** Units already collected in the current qualification window. */
  completedUnits: number;
  /** Copy under the count, e.g. "out of 16 orders". */
  unitsLabel: string;
  /** 0 - 1 share of the qualification window that is complete. */
  progress: number;
}

export const LoyaltyTierRing = ({
  rank,
  color,
  completedUnits,
  unitsLabel,
  progress,
}: LoyaltyTierRingProps) => {
  const clampedProgress = Math.min(1, Math.max(0, progress));

  return (
    <div className={styles.tier_ring} data-testid="loyalty-tier-ring">
      <span className={styles.tier_ring_badge}>
        <LoyaltyTierBadge rank={rank} color={color} />
      </span>
      <span className={styles.tier_ring_circle}>
        <svg viewBox="0 0 79.44 79.44" aria-hidden="true" focusable="false">
          <circle
            className={styles.tier_ring_progress_track}
            cx={CENTER}
            cy={CENTER}
            r={PROGRESS_RADIUS}
          />
          <circle
            className={styles.tier_ring_progress}
            cx={CENTER}
            cy={CENTER}
            r={PROGRESS_RADIUS}
            strokeDasharray={PROGRESS_CIRCUMFERENCE}
            strokeDashoffset={PROGRESS_CIRCUMFERENCE * (1 - clampedProgress)}
          />
          <circle
            className={styles.tier_ring_band}
            cx={CENTER}
            cy={CENTER}
            r={BAND_OUTER_RADIUS}
          />
          <circle
            className={styles.tier_ring_hole}
            cx={CENTER}
            cy={CENTER}
            r={BAND_INNER_RADIUS}
          />
        </svg>
        <span className={styles.tier_ring_value}>
          <strong>{localizedNumber(completedUnits)}</strong>
          <span>{unitsLabel}</span>
        </span>
      </span>
    </div>
  );
};
